<template>
  <div class="search-file" v-show="showComponent == 'file'">
    <div class="file-filter">
      <el-tabs v-model="searchObj.pro">
        <el-tab-pane label="全国" name="0"></el-tab-pane>
        <el-tab-pane label="地方" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-detail-content">
      <file-card @openPDF="openPDF" @delete="doDeleteFavorite" @add="doAddFavorite" :cardData="item" v-for="(item, index) in currentDocList" :key="index"></file-card>
      <div class="page-num">
        <el-pagination
          v-if="currentDocList.length"
          small
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="20"
          :total="totalNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index.js'
import fileCard from '../search/fileCard.vue'
export default {
  props: ['searchQObj', 'showComponent'],
  data () {
    return {
      searchObj: {
        pro: '',
        sort: '0',
        searchClass: [],
        searchAreaClass: [],
        classMenuData: [],
        classAreaMenuData: []
      },
      listLoading: false,
      noMore: false,
      loadingTip: false,
      totalNumber: 100,
      currentDocList: [],
      showFolderWindow: false,
      favarFolderList: [],
      ListFav: false,
      fileId: ''
    }
  },
  mounted () {
    this.doGetMenus()
  },
  methods: {
    handelList (successFlag) {
      if (successFlag) {
        this.showFolderWindow = false
        this.fileItem.collectionType = true
      }
    },
    // async doAddFavorite (item) {
    //   console.log('8888')
    //   console.log(this.favorList.totalNumber)
    //   if (!await this.gotoLogin()) return
    //   if (this.favorList.totalNumber >= 200) {
    //     this.$message({
    //       message: '我的收藏已到达200条嘞，删掉一条再添加吧~',
    //       type: 'warning'
    //     })
    //     return
    //   }
    //   if (!this.favarFolderList.length) {
    //     this.loading = this.$loading({
    //       lock: true,
    //       text: 'Loading',
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(256, 256, 256, 0.7)'
    //     })
    //     api.addFavorite({
    //       fileuploadId: item.id,
    //       folderId: -1
    //     }).then(res => {
    //       this.loading.close()
    //       if (res.code === 200 || res.code === 2006) {
    //         item.collectionType = true
    //       } else {
    //         this.$message({
    //           message: res.message || '收藏失败，请稍后再试',
    //           type: 'warning'
    //         })
    //       }
    //     })
    //   } else {
    //     this.fileId = item.id
    //     this.fileItem = item
    //     this.showFolderWindow = true
    //   }
    // },
    // async doDeleteFavorite (item, fromFav) {
    //   if (!await this.gotoLogin()) return
    //   this.loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(256, 256, 256, 0.7)'
    //   })
    //   api.deleteFavorite({
    //     fileuploadId: item.id
    //   }).then(res => {
    //     item.collectionType = false
    //     this.loading.close()
    //     if (fromFav) {
    //       this.refreshDetail()
    //     }
    //   })
    // },
    // doGetFavoriteList () {
    //   if (!this.loginFlag) return
    //   api.getFavoriteList({
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.favorList = res.data
    //     }
    //   })
    //   api.getFavoriteListFolder({}).then(res => {
    //     if (res.code === 200) {
    //       this.favarFolderList = res.data
    //     }
    //   })
    // },
    afterPDFOpen () {
      this.loading && this.loading.close()
      this.percent = 0
    },
    doGetMenus () {
      api.getMenus({
        type: 0
      }).then(res => {
        if (res && res.code === 200) {
          this.searchObj.classMenuData = JSON.parse(JSON.stringify(res.data).replace(/"child":\[\],/g, ''))
        }
      })
      api.getMenus({
        type: 1
      }).then(res => {
        if (res && res.code === 200) {
          this.searchObj.classAreaMenuData = JSON.parse(JSON.stringify(res.data).replace(/"child":\[\],/g, ''))
        }
      })
    },
    handleClassChange () {
      this.querySearchAsync(true)
    },
    handleCurrentChange (v) {
      console.log(v)
      this.pageNo = v
      this.querySearchAsync()
    },
    querySearchAsync (resetFlag) {
      if (!this.searchQ) {
        return
      }
      // monitor('搜索文件', 'file')
      if (resetFlag) {
        this.pageNo = 1
        this.currentDocList = []
        this.listLoading = true
        this.noMore = false
      }
      if (this.loadingTip || this.noMore) return
      this.loadingTip = true
      // this.loading = this.$loading({
      //   lock: true,
      //   spinner: 'none',
      //   background: 'rgba(0, 0, 0, 0)'
      // })
      api.getSuggest({
        pro: this.searchObj.pro,
        sort: this.searchObj.sort,
        name: this.searchQ,
        pages: 20,
        pageNo: this.pageNo,
        id: this.searchQObj.idSeach,
        classa: {
          0: this.searchObj.searchClass.join(','),
          1: this.searchObj.searchAreaClass.join(',')
        }[this.searchObj.pro] || ''
      }).then(res => {
        // this.loading.close()
        this.listLoading = false
        this.loadingTip = false
        if (res && res.code === 200) {
          this.totalNumber = res.data.totalNumber
          this.currentDocList = res.data.list
        } else {
          this.$message({
            type: 'error',
            message: res.message || '服务错误，请稍后再试'
          })
        }
      })
    },
    async openPDF (name, link, id) {
      this.$emit('itemClick', name, link, id)
    },
    gotoLogin () {
      return new Promise(resolve => {
        if (this.loginFlag) {
          resolve(true)
        } else {
          this.$router.replace('/login')
          resolve(false)
        }
      })
    }
  },
  watch: {
    showComponent (val) {
      if (val === 'file' && !this.currentDocList.length && !this.noMore) {
        // this.doGetFavoriteList()
        this.querySearchAsync(true)
      }
    },
    searchQObj (val) {
      this.searchQ = val.q
      this.currentDocList = []
      this.noMore = false
      if (this.showComponent === 'file') {
        // this.doGetFavoriteList()
        this.querySearchAsync(true)
      }
    },
    searchObj: {
      handler: function () {
        this.querySearchAsync(true)
      },
      deep: true
    }
  },
  components: {
    fileCard
  }
}
</script>

<style lang="scss">
.search-file {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100px;
  .file-filter {
    width: 100%;
    // flex: 0 0 auto;
    // display: flex;
    // justify-content: Space-between;
    align-items: center;
    text-align: center;
    // flex-wrap: wrap;
    padding: 8px 12px;
    background: #f4f5f6;
    .el-tabs{
      width: 100px;
      margin-left: calc(100% - 100px);
      text-align: right!important;
    }
  }
  .search-detail-content {
    margin-top: -16px;
    padding-bottom: 40px;
    background: #f1f1f1;
    .page-num{
      width: 100%;
      text-align: center;
    }
  }
}
</style>
